import request from "root/js/request";

export const getLocalizationIndex = async ({
  cabinet_id,
  exclude_region_clusters,
  barcode_id__not_in,
  sales_share_history_period,
  map,
  dates,
  alter_quantity,
}) => {
  const response = await request({
    url: "/api/analytics/forecasting/warehouse_supply_distribution_localization_index/",
    method: "post",
    params: {
      cabinet_id,
      exclude_region_clusters,
      barcode_id__not_in,
      sales_share_history_period,
    },
    data: {
      map,
      dates,
      alter_quantity,
    },
  });
  return response.data;
};
